import secureLocalStorage from 'react-secure-storage'

export const secureStorage = {
  getItem: (key: string): string | null => {
    try {
      const item = secureLocalStorage.getItem(key)
      return item ? String(item) : null
    } catch (error) {
      console.error('Error retrieving from secure storage:', error)
      return null
    }
  },

  setItem: (key: string, value: string): void => {
    try {
      secureLocalStorage.setItem(key, value)
    } catch (error) {
      console.error('Error saving to secure storage:', error)
    }
  },

  removeItem: (key: string): void => {
    try {
      secureLocalStorage.removeItem(key)
    } catch (error) {
      console.error('Error removing from secure storage:', error)
    }
  },
  clear: (): void => {
    try {
      secureLocalStorage.clear()
    } catch (error) {
      console.error('Error clearing secure storage:', error)
    }
  },
}
